<template>
  <div>
    <!--国际物流维护  -->
    <baseBreadcrumb :page="$t('message.internationalLogisticsMaintenance')"
      :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <el-tabs v-model="status" type="card" @tab-click="handleClick">
        <!-- 全部 -->
        <el-tab-pane :label="$t('message.all')" name="1"></el-tab-pane>
        <!-- 正常发 -->
        <el-tab-pane :label="$t('message.normalHair')" name="2"></el-tab-pane>
        <!--  停发-->
        <el-tab-pane :label="$t('message.stopHair')" name="3"></el-tab-pane>
        <!-- 删除 -->
        <el-tab-pane :label="$t('message.delete')" name="4"></el-tab-pane>
      </el-tabs>
      <div class="btn">
        <!-- 排序编号设置 -->
        <el-button type="primary" size="small" @click="showSort" v-if="status == 1 && isAuth(414)" class="primary">{{
          $t("message.sortNumberSetting") }}</el-button>
        <!-- 新增 -->
        <el-button type="primary" size="small" @click="add" v-if="isAuth(412)">{{
          $t("message.add")
        }}</el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 系统编号 -->
          <el-table-column align="center" :label="$t('message.sortNumbering')" prop="sort" width="80">
          </el-table-column>
          <!-- 物流ID -->
          <el-table-column align="center" :label="$t('message.logisticsId')" prop="id" width="80">
          </el-table-column>
          <!-- 发送方式名称 -->
          <el-table-column align="center" :label="$t('message.sendingModeName')" prop="name">
          </el-table-column>
          <!-- 发送方式Logo -->
          <el-table-column align="center" :label="$t('message.sendModeLogo')" prop="rowNumber">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover" v-if="scope.row.logo">
                <img :src="scope.row.logo" alt="" style="width: 300px; height: 300px" />
                <a href="javascript:;" slot="reference">
                  <el-image :src="scope.row.logo" style="width: 60px; height: 60px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <!-- 当前生效时间 -->
          <el-table-column align="center" :label="$t('message.currentEffectiveTime')" prop="rowNumber" width="200">
            <template slot-scope="scope" v-if="scope.row.useful_rule">
              <p>
                {{ $t("message.initiation") }}:
                {{ scope.row.useful_rule.start_at }}
              </p>
              <p>{{ $t("message.end") }}: {{ scope.row.useful_rule.end_at }}</p>
            </template>
          </el-table-column>
          <!-- 当前运费计算模式 -->
          <el-table-column align="center" :label="$t('message.currentFreightCalculationMode')" prop="remark">
            <template slot-scope="scope">
              <!-- 人工计算 自动计算 -->
              <span v-if="scope.row.useful_rule">
                {{
                  scope.row.useful_rule.is_auto_calculate
                    ? $t("message.automaticCalculation")
                    : $t("message.artificialCalculation")
                }}</span>
              <span v-else> —————— </span>
            </template>
          </el-table-column>
          <!-- 物流单号可用数量 -->
          <el-table-column align="center" :label="$t('message.availableQuantityOfLogisticsTrackingNumber')"
            prop="number_count_unused">
          </el-table-column>
          <!-- 当前发送状态 -->
          <el-table-column align="center" :label="$t('message.currentSendingStatus')" prop="remark">
            <template slot-scope="scope">
              {{
                scope.row.is_show
                  ? $t("message.normalHair")
                  : $t("message.stopHair")
              }}
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber">
            <template slot-scope="scope">
              <!-- 查看详情 -->
              <router-link :to="'/logisticsDetail?id=' + scope.row.id" target="_blank">
                <el-button size="mini" type="primary" class="primary">{{
                  $t("message.lookDetail")
                }}</el-button>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog title="物流方式新增表单" :close-on-click-modal="false" :visible.sync="addDialogVisible" width="600px" center>
      <div class="row">
        <!-- 发送方式 -->
        <div class="label">{{ $t("message.sendingModeName") }}</div>
        <div class="val">
          <el-input v-model="name" placeholder="请输入新增的物流方式的名称"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="addDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 确定 -->
        <el-button type="primary" @click="logisticsStore">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 排序编号设置: -->
    <el-dialog :title="$t('message.sortNumberSetting')" :close-on-click-modal="false" :visible.sync="sortDialogVisible"
      width="640px" center>
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#F8F8F8' }" style="width: 100%">
        <!-- 排序编号 -->
        <el-table-column align="center" :label="$t('message.sortNumber')" prop="sort" width="80">
        </el-table-column>
        <!-- 物流方式名称 -->
        <el-table-column align="center" :label="$t('message.nameOfLogisticsMode')" prop="name">
        </el-table-column>
        <!-- 修改后排序编号 -->
        <el-table-column align="center" :label="$t('message.modifiedSortNumber')">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.sorts" onfocus="this.select()"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="sortDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="logisticsUpdateSort">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {
        is_show: "",
        is_delete: "",
      },
      tableData: [],
      status: "1",
      addDialogVisible: false,
      name: "",
      sortDialogVisible: false,
    };
  },
  created() {
    this.logisticsList();
  },
  methods: {
    // 状态切换
    handleClick() {
      if (this.status == 1) {
        this.datas = {
          is_show: "",
          is_delete: "",
        };
      } else if (this.status == 2) {
        this.datas = {
          is_show: 1,
          is_delete: "",
        };
      } else if (this.status == 3) {
        this.datas = {
          is_show: 0,
          is_delete: "",
        };
      } else {
        this.datas = {
          is_show: "",
          is_delete: 1,
        };
      }
      this.logisticsList();
    },
    // 物流列表
    logisticsList() {
      this.$api.siteConfiguration.logisticsList(this.datas).then((res) => {
        res.data.forEach((item) => {
          item.sorts = item.sort;
        });
        this.tableData = res.data;
      });
    },
    showSort() {
      this.sortDialogVisible = true;
    },
    // 排序修改
    logisticsUpdateSort() {
      let datas = {
        list: [],
      };
      let flag = this.tableData.every((item) => item.sorts != "");
      if (!flag) return this.$message.error("有option未排序");
      this.tableData.forEach((item) => {
        datas.list.push({
          logistics_id: item.id,
          sort: item.sorts,
        });
      });
      this.$api.siteConfiguration.logisticsUpdateSort(datas).then((res) => {
        this.sortDialogVisible = false;
        this.logisticsList();
      });
    },
    // 显示新增
    add() {
      this.name = "";
      this.addDialogVisible = true;
    },
    // 新增物流方式
    logisticsStore() {
      if (this.name == "")
        return this.$message.error(this.$t("message.TheRequired"));
      this.$api.siteConfiguration
        .logisticsStore({ name: this.name })
        .then((res) => {
          this.addDialogVisible = false;
          this.logisticsList();
        });
    },
  },
};
</script>
<style lang='scss' scoped>
.body {
  position: relative;
}

.btn {
  margin-bottom: 20px;
  text-align: right;
  position: absolute;
  top: 20px;
  right: 20px;
}

.row {
  margin: 0 24px;
  padding: 24px;
  display: flex;
  background-color: #f8f8f8;

  .label {
    flex: 1;
    margin-right: 20px;
    line-height: 42px;
  }

  .val {
    flex: 4;
  }
}
</style>